export const networkInterfaces = {
    ETHERNET: { key: 'ETHERNET', label: 'Ethernet', interfaceName: 'eth0' },
    WIFI: { key: 'WIFI', label: 'Wi-Fi', interfaceName: 'wlan0' }
}